/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true, // Set to false to use static SVG
};

const greeting = {
  username: "Ifeoluwa Adeyanju",
  title: "Hi, I'm Ifeoluwa Adeyanju",
  subTitle: emoji(
    "Backend Developer 🚀 passionate about building secure and scalable APIs using Java and Spring Boot. Currently focused on backend systems, REST API development, and database integration."
  ),
  resumeLink:
    "./assets/Ife - Resume.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ife-aj",
  linkedin: "https://linkedin.com/in/ife-adeyanju-b2a9852b9",
  gmail: "ifeoluwaadeyanju6@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
title: "What I Do",
subTitle: "BACKEND DEVELOPER FOCUSED ON BUILDING SCALABLE AND SECURE SERVER-SIDE APPLICATIONS",

skills: [
emoji("⚡ Build RESTful APIs using Java and Spring Boot"),
emoji("⚡ Design backend systems with role-based authentication and JWT security"),
emoji("⚡ Integrate relational databases and manage data with SQL and ORM tools"),
emoji("⚡ Develop backend logic for web applications and connect APIs to frontends")
],

softwareSkills: [
{
skillName: "Java",
fontAwesomeClassname: "fab fa-java"
},
{
skillName: "Spring Boot",
fontAwesomeClassname: "fas fa-leaf"
},
{
skillName: "SQL",
fontAwesomeClassname: "fas fa-database"
},
{
skillName: "Git",
fontAwesomeClassname: "fab fa-git-alt"
},
{
skillName: "GitHub",
fontAwesomeClassname: "fab fa-github"
},
{
skillName: "HTML5",
fontAwesomeClassname: "fab fa-html5"
},
{
skillName: "CSS3",
fontAwesomeClassname: "fab fa-css3-alt"
},
{
  skillName: "Docker",
  fontAwesomeClassname: "fab fa-docker"
},
{
skillName: "JavaScript",
fontAwesomeClassname: "fab fa-js"
}
],

display: true
};


// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Covenant University University",
      logo: require("./assets/images/covenant university logo.webp"),
      subHeader: "Master of Industrial Mathematics-Computer Science",
      duration: "September 2022 - present"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
viewSkillBars: true,
experience: [
{
Stack: "Java & Core Programming",
progressPercentage: "70%"
},
{
Stack: "Spring Boot & Backend Development",
progressPercentage: "65%"
},
{
Stack: "Database Management (MySQL / SQL)",
progressPercentage: "60%"
},
{
Stack: "REST API Development",
progressPercentage: "65%"
},
{
Stack: "Frontend Basics (HTML / CSS / JavaScript)",
progressPercentage: "40%"
}
],
displayCodersrank: false
};


// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
title: "Featured Projects",
subtitle: "BACKEND PROJECTS I HAVE BUILT USING JAVA AND SPRING BOOT",

projects: [
{
image: require("./assets/images/chowdome.png"),
projectName: "Food Ordering System",
projectDesc:
"A full-stack food ordering platform built with Spring Boot and JWT authentication. The system supports multiple roles (USER, STORE, ADMIN), allowing users to order food while administrators manage stores and platform operations.",
footerLink: [
{
name: "GitHub Repository",
url: "https://github.com/ife-aj/chowdome"
}
]
},


{
  image: require("./assets/images/Folder.jfif"),
  projectName: "File Storage REST API",
  projectDesc:
    "A backend file storage service built with Spring Boot that allows users to upload, download, and manage files through REST API endpoints while storing files securely on the server.",
  footerLink: [
    {
      name: "GitHub Repository",
      url: "https://github.com/ife-aj/filestorage-api"
    }
  ]
}

],

display: true
};


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
title: emoji("Achievements And Certifications 🏆"),
subtitle: "Certifications I have earned demonstrating my skills and knowledge.",

achievementsCards: [
{
title: "Google Cybersecurity Certificate",
subtitle:
"Completed the Google Cybersecurity Certificate, gaining practical knowledge in cybersecurity fundamentals and best practices.",
image: require("./assets/images/google-cert.jfif"),
imageAlt: "Google Cybersecurity Logo",
footerLink: [
{
name: "View Certificate",
url: "https://www.linkedin.com/in/ife-adeyanju-b2a9852b9/details/certifications?profileUrn=urn%3Ali%3Afsd_profile%3AACoAAEx_LBIBqez-fu6w4J5H9UD8C9qp2CYz6Ks&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BHcL51usqSECez1IyP6Ggaw%3D%3D"
}
]
},
{
title: "Java Programming Certificate",
subtitle:
"Completed a comprehensive Java class covering object-oriented programming, data structures, and backend fundamentals.",
image: require("./assets/images/java cert.jpg"),
imageAlt: "Java Certificate Logo",
footerLink: [
{
name: "",
url: ""
}
]
}
],

display: true
};


// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// // Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+234 8139417774",
  email_address: "ifeoluwaadeyanju6@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  twitterDetails,
  contactInfo,
  isHireable,
  resumeSection
};
